var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 20",
    style: {
      enableBackground: "new 0 0 25 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1130 -239 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1146.5,249.8c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3l-4.6-5c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0-0.3,0.1l-4.6,5c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3s0.2,0.1,0.3,0.1h2.9v5c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.2,0.1,0.3,0.1h2.5c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3v-5h2.9C1146.4,249.9,1146.5,249.9,1146.5,249.8z  M1153.9,250.2c0.7,1,1.1,2.1,1.1,3.4c0,1.5-0.5,2.8-1.5,3.9s-2.2,1.6-3.5,1.6h-14.2c-1.6,0-3-0.6-4.1-1.9s-1.7-2.7-1.7-4.5 c0-1.2,0.3-2.4,0.9-3.4c0.6-1,1.4-1.8,2.4-2.3c0-0.3,0-0.5,0-0.6c0-2,0.7-3.7,2-5.1c1.3-1.4,2.9-2.1,4.7-2.1c1.4,0,2.6,0.4,3.7,1.2 s1.9,1.9,2.5,3.3c0.6-0.6,1.3-0.9,2.2-0.9c0.9,0,1.7,0.4,2.4,1.1c0.7,0.7,1,1.6,1,2.6c0,0.7-0.2,1.4-0.5,2 C1152.3,248.5,1153.2,249.2,1153.9,250.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.59b574b8ef8c1c0a8965bff1918d3aab.svg";
export { ForwardRef as ReactComponent };